export default {
  restaurantoffers: {
    subtitle: "عروض المطاعم",
    title1: "عروض",
    title2: "المطاعم الحالية",
    desc: "استفد من عروض الموردين الحصرية والأسعار الخاصة المتاحة للمطاعم على MAHAL.",

    offer1: {
      badge: "لفترة محدودة",
      title: "باقة الخضروات الطازجة",
      desc: "احصل على أسعار خاصة على الخضروات الطازجة اليومية من موردين موثوقين.",
      li1: "خصومات على الطلبات الكبيرة",
      li2: "توصيل في نفس اليوم",
      li3: "تسعير شفاف",
      btn: "عرض العرض",
    },

    offer2: {
      badge: "الأكثر طلبًا",
      title: "عرض الاحتياجات الشهرية",
      desc: "وفر أكثر مع الطلبات الشهرية بالجملة على الأرز والزيوت واحتياجات المطبخ.",
      li1: "أسعار أفضل للكميات الكبيرة",
      li2: "توصيل مجدول",
      li3: "دعم مميز",
      btn: "احصل على العرض",
    },

    offer3: {
      badge: "جديد",
      title: "عرض للمطاعم الجديدة",
      desc: "تحصل المطاعم الجديدة على أسعار خاصة للطلبات الأولى.",
      li1: "سعر خاص للتسجيل",
      li2: "موردون موثوقون",
      li3: "طلب سهل",
      btn: "ابدأ الآن",
    },
  },
};